import React from "react";
import Navbar from "../components/Navbar";

const Contact = () => {
    return (
        <div>
            <Navbar/>
            <h1>CONTACT</h1>
        </div>
    );
};

export default Contact;
